import React, { useState } from 'react';
import { InputNumber, Button, Card, Spin, message, Typography, Input, Row, Col } from 'antd';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSettings, updateSettings } from '../api';

const { Title } = Typography;

// Служебные поля, которые не отображаем как карточки
const HIDDEN_KEYS = ['_id', 'modified'];

const Settings = () => {
  const queryClient = useQueryClient();
  const [values, setValues] = useState({});

  const { isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: getSettings,
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data) setValues(data);
    },
  });

  const { mutate: mutateSave, isLoading: isSaving } = useMutation(updateSettings, {
    onSuccess: (data) => {
      message.success('Настройки сохранены');
      setValues(data);
      queryClient.invalidateQueries(['settings']);
    },
    onError: (error) => {
      message.error(error?.response?.data?.message || 'Ошибка при сохранении настроек');
    },
  });

  const handleChange = (key, val) => {
    setValues((prev) => ({ ...prev, [key]: val }));
  };

  const handleSave = () => {
    const payload = {};
    Object.keys(values).forEach((key) => {
      if (!HIDDEN_KEYS.includes(key)) {
        payload[key] = values[key];
      }
    });
    mutateSave(payload);
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
        <Spin size="large" />
      </div>
    );
  }

  const settingKeys = Object.keys(values).filter((k) => !HIDDEN_KEYS.includes(k));

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Настройки</Title>

      <Row gutter={[16, 16]}>
        {settingKeys.map((key) => {
          const val = values[key];
          const isNumber = typeof val === 'number';

          return (
            <Col xs={24} sm={12} md={8} lg={6} key={key}>
              <Card title={key} size="small">
                {isNumber ? (
                  <InputNumber
                    value={val}
                    onChange={(v) => handleChange(key, v)}
                    style={{ width: '100%' }}
                  />
                ) : (
                  <Input
                    value={val}
                    onChange={(e) => handleChange(key, e.target.value)}
                  />
                )}
              </Card>
            </Col>
          );
        })}
      </Row>

      {settingKeys.length > 0 && (
        <Button
          type="primary"
          onClick={handleSave}
          loading={isSaving}
          style={{ marginTop: 24 }}
        >
          Сохранить
        </Button>
      )}
    </div>
  );
};

export default Settings;
